import styled from 'styled-components';

import { Snackbar } from '@gympass/yoga';

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const NotificationBar = styled(Snackbar)`
  right: auto;
  min-width: initial;

  svg {
    fill: ${({ theme }) => theme.yoga.colors.stamina};
  }
`;
